// ------
// Mobile menu toggle
// ------

const toggleMenuClass = (toggle) => {
  document.body.classList.toggle('is-open-menu', toggle);
};

const toggleSearchClass = (toggle) => {
  document.body.classList.toggle('is-open-search', toggle);
  toggleBodyScrollLock(toggle);
};

attachEvent('.header-main__hamburger', 'click', (ev) => {
  ev.preventDefault();
  const isOpen = document.body.classList.contains('is-open-menu');
  toggleMenuClass(!isOpen);
});

// ------
// Add class to body after some scroll
// ------
function addScrollingClass() {
  const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('is-scrolled', topOffset > 10);
}

addScrollingClass();

let ticking = false;
document.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      addScrollingClass();
      ticking = false;
    });
    ticking = true;
  }
});

let lastScrollTop = 0;
window.addEventListener(
  'scroll',
  () => {
    const isScrolledTop = window.pageYOffset || document.documentElement.scrollTop;
    document.body.classList.toggle('is-scrolled-up', isScrolledTop < lastScrollTop);
    lastScrollTop = isScrolledTop <= 0 ? 0 : isScrolledTop;
  },
  false,
);

// ------
// Open search
// ------
const searchInput = document.querySelector('.menu__search-input-field');

attachEvent('.menu__search-trigger', 'click', (ev) => {
  const isOpen = document.body.classList.contains('is-open-search');
  toggleSearchClass(!isOpen);
  setTimeout(() => {
    searchInput.focus();
  }, 50);
  ev.preventDefault();
});

// ------
// Close Header Search When Escape Key Press
// ------

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    toggleSearchClass(false);
    searchInput.blur();
  }
});
